document.addEventListener('DOMContentLoaded', function() {
  const researchBlocks = document.querySelectorAll('.funded-research-project-block');

  researchBlocks.forEach(block => {
    const toggleButton = block.querySelector('.funded-research-project-block__toggle');
    const content = block.querySelector('.funded-research-project-block__content');
    const arrow = toggleButton.querySelector('.arrow');

    toggleButton.addEventListener('click', function() {
      // Toggle visibility of the content
      content.classList.toggle('active');

      // Toggle text between 'Collapse' and 'Expand' based on the current state
      toggleButton.innerHTML = content.classList.contains('active') ? 'Collapse <span class="arrow up"></span>' : 'Expand <span class="arrow down"></span>';

      // Toggle arrow direction based on the current state
      arrow.classList.toggle('down', !content.classList.contains('active'));
      arrow.classList.toggle('up', content.classList.contains('active'));
    });
  });
});
